import { render, staticRenderFns } from "./ProductViewDetail.vue?vue&type=template&id=5f8ec000&"
import script from "./ProductViewDetail.vue?vue&type=script&lang=js&"
export * from "./ProductViewDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductViewDetail.vue?vue&type=style&index=0&id=5f8ec000&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports